import { Breakpoint } from '@mui/material'

export const breakpointsValues: Record<Breakpoint, number> = {
  xs: 0,
  sm: 430,
  px526: 526, // custom 526px
  md: 640,
  px975: 975, //custom 975px
  lg: 1024,
  px1240: 1240, //custom 1240px
  px1350: 1350, //custom 1350px
  xl: 1440,
  px1640: 1640, //custom 1640px
}

export const breakpointsKeys = Object.keys(breakpointsValues) as Breakpoint[]
